import React from 'react';
import { debounce } from 'ts-debounce';
import { Button, Spinner } from '@components';
import { Image as ImageUtils } from '@utils';
import GlobalCtx from '@components/globalContext';
import ImageApi from '@api/image';

import Thresholds from './Thresholds';

const Controls = (): JSX.Element => {
  const { app, setApp, image, setImage } = React.useContext(GlobalCtx);
  const {
    imageContent: { mod },
  } = image;

  const updateThresholds = debounce(async (low: number, high: number) => {
    setImage({
      ...image,
      isUpdating: true,
    });
    setApp({
      ...app,
      thresholds: {
        ...app.thresholds,
        updatedAt: Date.now(),
        low,
        high,
      },
    });
    const resp = await ImageApi.update({
      clientId: app.clientId,
      low,
      high,
      filename: image.imageContent.filename,
    }).catch(() => {
      setApp({
        ...app,
        notice: {
          ...app.notice,
          isVisible: true,
          message: 'Unable to update image.',
        },
      });
      setImage({
        ...image,
        isUpdating: false,
      });
    });
    if (resp.url) {
      setImage({
        ...image,
        isUpdating: false,
        imageContent: {
          ...image.imageContent,
          mod: resp.url,
          previewMod: resp.preview_url,
        },
      });
    }
  }, 200);

  const downloadFilename = ImageUtils.getDownloadFilename(mod);
  return (
    <div className="flex relative">
      {image.isUpdating && (
        <div className="absolute w-full">
          <Spinner className="place-content-center flex mt-3" />
        </div>
      )}
      <div className="place-self-center text-center w-full py-24">
        <p className="font-bold text-lg">Adjust your image:</p>
        <Thresholds className="border-sky-100 border-y py-6 my-3" onChange={updateThresholds} />
        <Button href={mod} download={downloadFilename} className="mt-2">
          Download
        </Button>
      </div>
    </div>
  );
};

export default Controls;
